import React, { useEffect, useState } from "react"
import { withRouter, Link } from "react-router-dom"

import MetaTags from "react-meta-tags"

import { Container } from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import { getData, options } from "./data"
import { Filters } from "./Filters"
import Table from "./Table"
import axios from "axios"
import {API_URL, sitename} from "constants/constants"
import moment from "moment";
const GGRReport = props => {
  const [GGRReport, setGGRReport] = useState([])
  const [selectedMonth, setSelectedMonth] = useState(moment().format("YYYY-MM"))
  const [item, setItem] = useState('All')
  const options = [
    { label: "All", value: "All" },
    { label: "Sports", value: "Sports" },
    { label: "Pragmatic Games", value: "PragmaticGames" },
    { label: "Turbo Games", value: "TurboGames" },
    { label: "Spribe Games", value: "SpribeGames" },
    { label: "BigWins", value: "BigWins" },
  ]
  const [loadingMessage, setLoadingMessage] = useState("1");
  useEffect(() => {
    call()
  }, [])

  const call = () => {
    setLoadingMessage("1");
    axios({
      method: "get",
      url: `${API_URL}/admin/reports/ggr-reports?month=${selectedMonth}&type=${item}`,
    })
        .then(function (response) {
          setGGRReport(response?.data?.data)
          setLoadingMessage("0");
        })
        .catch(function (response) {
        })
  }


  return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>{sitename}</title>
          </MetaTags>
          <Container fluid>
            {/* Render Breadcrumb */}
            <Breadcrumbs title="Admin" breadcrumbItem="GGR Report" />
          </Container>
          <Filters
              setSelectedMonth={setSelectedMonth}
              selectedMonth={selectedMonth}
              item={item}
              setItem={setItem}
              options={options}
              call={e => {
                call()
              }}
          />
          <Table
              data={GGRReport}
              setLoadingMessage={setLoadingMessage}
              loadingMessage={loadingMessage}
          />
        </div>
      </React.Fragment>
  )
}

export default withRouter(GGRReport)
